import UsersApi from '@/api/usersApi';

const state = {
  users: {
    items: [],
    count: 0,
    loading: false,
    page: 1,
    search: '',
    pagesLength: 0,
    take: 8
  }
};

const getters = {};

const actions = {
  async getAllUsers({ commit, rootState, state }, payload) {
    commit('SAVE_USERS_LOADING', { loading: true });

    try {
      payload = payload || { page: state.users.page, search: state.users.search, roles: [] };

      let skip = (payload.page - 1) * state.users.take;
      let { data } = await new UsersApi(rootState.account.token).getAll(
        payload.search,
        skip,
        state.users.take,
        payload.roles
      );

      if (data.result.items.length === 0 && data.result.totalCount > 0) {
        payload.page--;
        skip = (payload.page - 1) * state.users.take;
        ({ data } = await new UsersApi(rootState.account.token).getAll(
          payload.search,
          skip,
          state.users.take,
          payload.roles
        ));
      }

      commit('SAVE_USERS', {
        users: data.result.items,
        page: payload.page,
        pagesLength: Math.ceil(data.result.totalCount / state.users.take),
        totalCount: data.result.totalCount,
        search: payload.search
      });
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    } finally {
      commit('SAVE_USERS_LOADING', { loading: false });
    }
  },
  async createUser({ rootState, dispatch }, payload) {
    try {
      await new UsersApi(rootState.account.token).create(
        payload.userName,
        payload.name,
        payload.surname,
        payload.emailAddress,
        payload.roleNames,
        payload.isActive,
        payload.password
      );
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }

    await dispatch('getAllUsers');
  },
  async updateUser({ dispatch }, payload) {
    try {
      await new UsersApi().update(
        payload.id,
        payload.userName,
        payload.name,
        payload.surname,
        payload.emailAddress,
        payload.roleNames,
        payload.isActive
      );
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }

    await dispatch('getAllUsers');
  },
  async deleteUser({ rootState, dispatch }, payload) {
    try {
      await new UsersApi(rootState.account.token).delete(payload.id);
    } catch (ex) {
      // TODO: handle
      console.error(ex);
    }

    await dispatch('getAllUsers');
  }
};

const mutations = {
  SAVE_USERS(state, payload) {
    state.users = {
      ...state.users,
      items: payload.users,
      page: payload.page,
      pagesLength: payload.pagesLength,
      count: payload.totalCount,
      search: payload.search
    };
  },
  SAVE_USERS_LOADING(state, payload) {
    state.users = {
      ...state.users,
      loading: payload.loading
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
